const StickyTrial = () => {
  return (
    <div className="md:hidden sticky">
      <button className="text-center w-full py-2 text-sm tracking-wider font-semibold flex items-center justify-center bg-lime-400 text-white hover:bg-lime-500 duration-500">Free Trial</button>
    </div>
  );
};

export default StickyTrial;
